var kebabToCamel = function (s) { return s.replace(/-([a-z])/, function (_, p1) { return p1.toUpperCase(); }); };
export var kebabToCamelObjectKeys = function (obj) {
    if (obj === void 0) { obj = {}; }
    return Object.keys(obj).reduce(function (result, key) {
        result[kebabToCamel(key)] = obj[key];
        return result;
    }, {});
};
//# sourceMappingURL=textUtils.js.map